import {BreadcrumbType} from 'platform/components';

import {useGetTeamQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {usePermissions} from '@dms/shared';

import {useRequiredParams} from 'shared/web';

import {TeamForm} from '../../components/TeamForm/TeamForm';
import {MembersOverview} from './components/MembersOverview';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.settings.labels.teamManagement'),
    href: settingsRoutes.teamManagement,
  },
];

export function TeamDetail() {
  const {id: teamId} = useRequiredParams();

  const teamQuery = useGetTeamQuery({id: teamId});

  const [canUpdateTeam] = usePermissions({
    permissionKeys: ['teamUpdate'],
  });

  const isReadOnlyForm = !canUpdateTeam;

  return (
    <SettingsTemplate
      isLoading={teamQuery.isLoading}
      isError={teamQuery.isError}
      header={{
        breadcrumbs,
        title: teamQuery.data?.name ?? i18n.t('page.settings.labels.teamManagementDetail'),
      }}
      headerVariant="v2"
      data-testid={testIds.settings.teamManagementDetail('page')}
      tabs={[
        {
          queryId: 'general',
          title: i18n.t('general.labels.general'),
          content: <TeamForm teamId={teamId} isReadOnlyForm={isReadOnlyForm} />,
        },
        {
          queryId: 'members',
          title: i18n.t('general.labels.teamMembers'),
          content: <MembersOverview />,
        },
      ]}
    />
  );
}
